<template>
  <v-card width="700px">
    <v-card-title class="text-h6">
      Edit Details
      <v-spacer> </v-spacer>
      <v-spacer> </v-spacer>
      <v-btn depressed @click="$emit('closeDialog')" fab x-small icon
        ><v-icon>mdi-close</v-icon></v-btn
      >
    </v-card-title>

    <v-card-text class="mt-4">
      <v-form v-model="valid" ref="form">
        <v-row>
          <v-col cols="12" md="6" sm="6">
            <label class="labelFontsize my-0 required"
              >Purpose of Remitance</label
            >
            <v-autocomplete
              class="rounded"
              dense
              outlined
              item-text="txt"
              item-value="val"
              :items="por_list"
              :rules="FieldRequired('Purpose of remittance')"
              v-model="txn_data.reason_of_remittance_cd"
              placeholder="Purpose of remittance"
            ></v-autocomplete>
          </v-col>
          <v-col cols="12" md="6" sm="6">
            <label class="labelFontsize my-0 required">Source of Funds</label>
            <v-autocomplete
              class="rounded"
              dense
              outlined
              item-text="txt"
              item-value="val"
              :items="sof_list"
              :rules="FieldRequired('Souce of funds')"
              v-model="txn_data.source_of_fund_cd"
              placeholder="Souce of funds"
            ></v-autocomplete>
          </v-col>
        </v-row>
      </v-form>
    </v-card-text>
    <v-divider class="mt-0"></v-divider>
    <v-card-actions>
      <v-spacer></v-spacer>
      <v-btn depressed color="primary" outlined @click="$emit('closeDialog')">
        <v-icon small class="me-2">mdi-close-circle-outline</v-icon>cancel
      </v-btn>
      <v-btn depressed color="primary" @click="updateTxnInfo()"> Update </v-btn>
    </v-card-actions>
  </v-card>
</template>

<script>
import commonService from "@/services/CommonService/commonService.js";
import PaymentService from "@/services/PaymentService/paymentService.js";
import alerts from "@/mixins/alerts";
import { FieldRequired } from "@/utils/validation.js";
export default {
  name: "recieverInfoEdit",
  mixins: [alerts],
  data() {
    return {
      FieldRequired,
      sof_list: [],
      por_list: [],
      valid: false,
      isedit: false,
      transaction_id: null,
      txn_data: {
        reason_of_remittance_cd: "",
        source_of_fund_cd: "",
      },
    };
  },
  props: {
    transactionInfo: {
      type: Object,
    },
    user_type: {
      type: String,
    },
  },
  mounted() {
    this.getSofData();
    this.getPorData();
    this.transaction_id = this.$route.query.payment_id
      ? this.$route.query.payment_id
      : null;
    this.mapTxnData();
  },

  watch: {},
  methods: {
    async getSofData() {
      try {
        const responseData = await commonService.getparameterdrop({
          parameter_code: "SOF",
          user_type: this.user_type === "Individual" ? "IND" : "BUS",
        });

        if (responseData.data.status_code === 200) {
          this.sof_list = responseData.data.data.map((i) => {
            return {
              txt: i.value,
              val: i.value_code,
            };
          });
        }
        console.log("getRelationship", responseData);
      } catch (e) {
        console.error(e);
      }
    },
    async getPorData() {
      try {
        const responseData = await commonService.getparameterdrop({
          parameter_code: "POR",
          user_type: this.user_type === "Individual" ? "IND" : "BUS",
        });

        if (responseData.data.status_code === 200) {
          this.por_list = responseData.data.data.map((i) => {
            return {
              txt: i.value,
              val: i.value_code,
            };
          });
        }
        console.log("getRelationship", responseData);
      } catch (e) {
        console.error(e);
      }
    },
    async updateTxnInfo() {
      const validate = this.$refs.form.validate();
      if (validate) {
        try {
          const responseData = await PaymentService.updateTxnDetails(
            {
              txn_pin: this.transaction_id,
            },
            this.txn_data
          );
          if (responseData && responseData.data.status_code === 200) {
            this.$emit("closeDialog");
            this.$emit("TxnDataUpdated");
            this.showAlertSuccess(responseData.data.message);
          } else {
            this.showAlertError(`Failed: ${responseData.data.message}`);
          }
        } catch (e) {
          console.error(e);
        }
      }
    },
    mapTxnData() {
      this.txn_data = {
        source_of_fund_cd: this.transactionInfo.source_of_funds.value_code,
        reason_of_remittance_cd:
          this.transactionInfo.purpose_of_remittance.value_code,
      };
    },
  },
};
</script>

<style lang="scss" scoped>
@import "@/global.scss";
.required:after {
  content: " *";
  color: red;
}
</style>
